"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTonNetwork = void 0;
const ton_1 = require("ton");
const assert_1 = __importDefault(require("assert"));
const ton_access_1 = require("@orbs-network/ton-access");
class CustomTonNetwork {
    constructor(walletKeyProvider, apiV2Config) {
        this.walletKeyProvider = walletKeyProvider;
        this.apiV2Config = apiV2Config;
        this.workchain = 0;
    }
    async setUp() {
        const walletKey = this.walletKeyProvider();
        (0, assert_1.default)(walletKey, "Wallet key is undefined!");
        const endpoint = await (0, ton_access_1.getHttpV4Endpoint)({ network: "testnet" });
        const wallet = ton_1.WalletContractV4.create({
            publicKey: walletKey.publicKey,
            workchain: 0,
        });
        this.api = new ton_1.TonClient4({ endpoint });
        this.oldApi = new ton_1.TonClient({
            endpoint: this.apiV2Config.apiEndpoint,
            apiKey: this.apiV2Config.apiKey,
        });
        this.walletContract = this.oldApi.open(wallet);
        this.sender = this.walletContract.sender(walletKey.secretKey);
    }
    async isContractDeployed(address) {
        const seqno = await this.walletContract.getSeqno();
        return address == undefined || this.api.isContractDeployed(seqno, address);
    }
    open(contract) {
        return this.api.open(contract);
    }
}
exports.CustomTonNetwork = CustomTonNetwork;
//# sourceMappingURL=CustomTonNetwork.js.map